import {Injectable} from '@angular/core';
import {ResourceService} from '~/app/core/common/services/ResourceService';
import {OrderSchedule} from '~/app/core/common/models/orderSchedule';

import {OrderScheduleSerializer} from '~/app/core/common/serializers/OrderScheduleSerializer';
import {map} from 'rxjs/operators';
import {ApiService} from '~/app/core/common/services/api.service';
import {orderStatusTxt} from '~/app/core/common/enums/OrderStatusTxt';
import {BaseService} from '~/app/core/common/services/base.service';
import {endOfDay, format, startOfDay} from 'date-fns';

@Injectable({
    providedIn: 'root'
})
export class ScheduleService extends ResourceService<OrderSchedule> {
    private _orderSchedule: OrderSchedule[];
    public events: any[] = [];

    constructor(public baseService: BaseService,
                public apiService: ApiService,
    ) {

        super(baseService,
            '',
            '',
            new OrderScheduleSerializer());
    }

    get orderSchedule(): OrderSchedule[] {
        return this._orderSchedule;
    }

    set orderSchedule(value) {
        this._orderSchedule = value;
    }

    public static GetString(enumNumber: number) {
        switch (enumNumber) {
            case 0: {
                return orderStatusTxt.NOT_PLACED;
            }
            case 1: {
                return orderStatusTxt.DUE;
            }
            case 2: {
                return orderStatusTxt.STARTED;
            }
            case 3: {
                return orderStatusTxt.PLACED;
            }
            case 4: {
                return orderStatusTxt.CONFIRMED;
            }
            case 5: {
                return orderStatusTxt.CONFIRMED_ACK;
            }
            case 6: {
                return orderStatusTxt.SHIPPED;
            }
            case 7: {
                return orderStatusTxt.DELIVERED;
            }
            case 8: {
                return orderStatusTxt.UNSCHEDULED_OFFLINE;
            }

        }
    }

    public static GetColors(type: number) {
        switch (type) {
            case 0: {
                return '#FF0000';
            }
            case 1: {
                return '#FF0000';
            }
            case 2: {
                return '#0000FF';
            }
            case 3: {
                return '#0000FF';
            }
            case 4: {
                return '#0000FF';
            }
            case 5: {
                return '#228b22';
            }
            case 6: {
                return '#228b22';
            }
            case 7: {
                return '#228b22';
            }
            case 8: {
                return '#FF0000';
            }
        }
    }

    async getOrderSchedules(customerId: string) {
        const callScheduleURL = this.apiService.callScheduleURL.replace('customer_number', customerId);
        this.orderSchedule = await this.baseService.getHttpObject('getOrderSchedules',
            'schedule-service', callScheduleURL)
            .pipe(map((data: any) => this.convertData(data)))
            .toPromise().then(results => results as OrderSchedule[]);

        this.orderSchedule.forEach(event => {
            event.documentType = 'customer_schedule';
        });
        return this.orderSchedule;
    }

    async CheckOrderSubmitted(customerId: string, trackingId: string): Promise<boolean> {
        const callScheduleURL = this.apiService.callScheduleURL.replace('customer_number', customerId);
        const orders = await this.baseService.getHttpObject('getOrderSchedules',
            'schedule-service', callScheduleURL)
            .pipe(map((data: any) => this.convertData(data)))
            .toPromise().then(results => results as OrderSchedule[]);
        let exists = false;
        for (const item of orders) {
            if (this.dateComparer(item.callDate, new Date().toDateString())) {
                if (+item.status > 1) {
                    if (item.trackingId.toString() !== trackingId) {
                        exists = true;
                        break;
                    }
                }

            }
        }
        console.log('Order Exists ' + exists);
        return exists;

    }

    async updateCalendarEvents() {
        const tempEvents = [];
        await this.orderSchedule.forEach(callSchedule => {
            const calendarEvent = this.CreateCalendarEvent(callSchedule);
            tempEvents.push(calendarEvent);
        });
        this.events = tempEvents;

    }


    CreateCalendarEvent(value: OrderSchedule) {
        const enumStatus = ScheduleService.GetString(+value.status);
        const enumColor = ScheduleService.GetColors(+value.status);
        const colorProp = {primary: enumColor, secondary: '#a8a8a8'};
        const enumDeliveryDate = this.dateParser(value.deliveryDateFormatted);
        const enumOrderDue = this.dateParser(value.callDateFormatted);

        const isoDate = this.dateParser(value.callDateFormatted);

        return {
            start: startOfDay(`${isoDate.substring(0, 10)} ${isoDate.substring(11, 19)}`),
            end: endOfDay(`${isoDate.substring(0, 10)} ${isoDate.substring(11, 19)}`),
            title: `<span class="eventdata">- Order Due : ${enumOrderDue}</span><br>&emsp;&nbsp;&nbsp;&nbsp;<span class="eventdata">Delivery Date : ${enumDeliveryDate}</span><br>&emsp;&nbsp;&nbsp;&nbsp;<span class="eventdata">PO Number : ${value.orderNo}</span><br>&emsp;&nbsp;&nbsp;&nbsp;<span class="eventdata">Status : ${enumStatus}</span>`,
            color: colorProp,
            allDay: true,
            meta: value
        };
    }

    dateParser(dateStr: string): string {
        // 2019.11.5 08:45 (24hr); - converting valid date format like this

        const datetime = dateStr.replace('.', '-').replace('.', '-');
        return format(datetime, 'MM-dd-yyyy');
    }

    GetDatesWithoutTimes(date: Date) {
        return date.setHours(0, 0, 0, 0);
    }

    dateComparer(dateString: Date, compareTo: string) {
        if (this.GetDatesWithoutTimes(new Date(dateString)) === this.GetDatesWithoutTimes(new Date(compareTo))) {
            return true;
        } else {
            return false;
        }
    }
}
